import * as React from "react";
const SvgFiRrPersonPraying = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-person-praying_svg__a)">
      <path
        fill="#062147"
        d="M13 2.468a2.5 2.5 0 1 1 5-.001 2.5 2.5 0 0 1-5 0m8.748 5.868a1 1 0 0 0-1.41-.084l-3.063 2.714-1.918-2.685c-.486-.937-1.295-1.652-2.223-1.992a3.04 3.04 0 0 0-2.074-.184 3.15 3.15 0 0 0-2.019 1.69l-2.649 6.169c-.734 1.497-.4 2.787 1.057 3.974L12.96 22H4.983a1 1 0 0 0 0 2h9.525c.645 0 1.214-.412 1.415-1.024a1.49 1.49 0 0 0-.53-1.666l-6.719-4.952c-.835-.681-.729-1.02-.465-1.56l2.65-6.168c.143-.292.406-.51.723-.595.238-.065.47-.042.792.102.405.15.752.409 1.007.747l-2.404 5.729a1 1 0 0 0 1.843.774l1.907-4.546.955 1.337a1.936 1.936 0 0 0 2.66.5c.04-.026 3.32-2.93 3.32-2.93a1 1 0 0 0 .084-1.412z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-person-praying_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPersonPraying;
